/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getBillPayments,
    getBillPayment,
    printBillPayment,
    createBillPayments,
    updateBillPayments,
    deleteBillPayments,
} from "Modules/supply_chain/bills/config/api.bill_payments";

const state = {
    page: {},
    form: {},
    bill_payments: [],
    bill_payment_options: [],
    selectedBillPayment: {
        payment_id: null,
        company_id: "",
        bill_payment_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        bill_payment_details: [],
    },
    bill_payments_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_bill_payments: {
        payment_id: {
            name: "payment_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_id: {
            name: "bill_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payment_date: {
            name: "payment_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        amount: {
            name: "amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[11]|decimal|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        payment_method_id: {
            name: "payment_method_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payment_status_id: {
            name: "payment_status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        reference_number: {
            name: "reference_number",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        notes: {
            name: "notes",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    bill_payments: (state) => {
        return state.bill_payments;
    },
};

// actions
const actions = {
    async fetchBillPayments({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getBillPayments({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "bill_payment_options",
                        with: response.data.bill_payments,
                    });
                } else {
                    commit("mutate", {
                        property: "bill_payments",
                        with: response.data.bill_payments,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchBillPayment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getBillPayment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedBillPayment",
                    with: response.data.bill_payment,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printBillPayment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printBillPayment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveBillPayment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["payment_id"] === "undefined" || body["payment_id"] == null || body["payment_id"] == "") {
                delete body["payment_id"];
                response = await createBillPayments({ body: body, headers: config.headers });
            } else {
                let payment_id = body["payment_id"];
                delete body["payment_id"];
                response = await updateBillPayments({ body: body, headers: config.headers }, payment_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteBillPayment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteBillPayments(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetBillPayments(state) {
        state.page = {};
        state.form = {};
        state.bill_payments = [];
        state.bill_payment_options = [];
        state.selectedBillPayment = {
            payment_id: null,
            company_id: "",
            bill_payment_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            bill_payment_details: [],
        };
        state.bill_payments_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
